'use es6';

import { omit, pick, memoize } from 'underscore';
import SeamlessImmutable from 'seamless-immutable';
import ImmutableModel from 'DesignData/models/ImmutableModel';
import { createCssClassData } from 'DesignData/lib/css';
import FormAttributes from 'DesignData/constants/FormWidgetAttributes';
import { form } from 'DesignData/enums/SmartWidgetTypes';
import * as smartObjectHelper from 'DesignData/helpers/smartObjectHelper';
import { isVirtualCellType } from 'DesignData/helpers/widgets';
const LEGACY_FIELDS = ['editable', 'isEmailFlexArea', 'isFlexArea', 'isContainer', 'is_container', 'isInContainer', 'is_in_container', 'isInFlexArea', 'is_in_flex_area', // The BE copies these `params` fields to the body. Don't need them there.
// TODO: BE Bug - these fields are being copied from params to main body.
'cssClass', 'cssStyle', 'cssId', 'cssIdStr']; // Check legacy fields before creating a new object - the latter is a much greater performance penalty.

function hasLegacyField(props) {
  return LEGACY_FIELDS.some(name => name in props);
}

function ensureInt(obj, field) {
  if (typeof obj[field] === 'string') {
    obj[field] = parseInt(obj[field], 10);
  }
}
/*
 * Return a memoized function to create normalized CSS class data.
 */


const makeGetCssClassData = () => {
  const empty = SeamlessImmutable(createCssClassData(null));
  let data = empty;

  const hasher = cssClass => {
    return typeof cssClass === 'string' ? cssClass.trim() : '';
  };

  function getCssClassData(__cssClass) {
    const cssClass = hasher(__cssClass);

    if (!cssClass) {
      return data = empty;
    }

    const newData = createCssClassData(cssClass);
    return data = data.merge(newData);
  }

  return memoize(getCssClassData, hasher);
};

const privy = (() => {
  const map = new WeakMap();
  return self => {
    let hash = map.get(self);

    if (!hash) {
      hash = {
        getCssClassData: makeGetCssClassData()
      };
      map.set(self, hash);
    }

    return hash;
  };
})();
/**
 *
 * @class
 */


export default class LayoutWidget extends ImmutableModel {
  constructor(props) {
    // Remove legacy or unneeded fields
    const __props = hasLegacyField(props) ? omit(props, LEGACY_FIELDS) : Object.assign({}, props);

    ensureInt(__props.x);
    ensureInt(__props.w); // Convert { type: 'cell', editable: true } to { type: 'virtual_cell' }
    // @see {@link https://git.hubteam.com/HubSpot/DesignManagerUI/issues/3971}

    if (props.type === 'cell' && props.editable) {
      __props.type = 'virtual_cell';
    }

    return super(__props);
  }

  toJSON() {
    const changes = isVirtualCellType(this.type) ? {
      type: 'cell',
      editable: true
    } : {
      editable: false
    };
    return Object.assign({}, this, changes);
  } // TODO: Move this to a selector

  /**
   *
   * @return {DesignData/models/css/CssClassData}
   */


  getCssClassData() {
    return privy(this).getCssClassData(this.params.css_class);
  }

  getSmartProperties() {
    return smartObjectHelper.getSmartProperties(this.params);
  }

  getTargetType() {
    return smartObjectHelper.getTargetType(this.type);
  }

  getTargetContentType() {
    return smartObjectHelper.getTargetContentType(this.type);
  }

  getTargetedContent() {
    if (this.type === form) {
      const formData = pick(this.params, FormAttributes);
      return {
        content: formData
      };
    }

    return smartObjectHelper.getTargetedContent(this.type, this.params);
  }

}